import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const SignalPoorIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsxs(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "SignalPoor",
    children: [/*#__PURE__*/_jsx("circle", {
      cx: "16",
      cy: "25.429",
      r: "2"
    }), /*#__PURE__*/_jsx("path", {
      d: "M31.015 11.537c-3.09-2.79-6.823-4.676-10.794-5.456a1.143 1.143 0 0 0-.441 2.242c3.565.701 6.92 2.4 9.704 4.91a1.14 1.14 0 0 0 1.614-.083 1.143 1.143 0 0 0-.083-1.613ZM13.122 6.973a1.15 1.15 0 0 0-1.34-.904c-3.97.77-7.707 2.65-10.807 5.434a1.144 1.144 0 0 0 1.527 1.7c2.791-2.508 6.152-4.198 9.716-4.89.62-.12 1.025-.72.904-1.34ZM20.319 12.425a1.142 1.142 0 1 0-.637 2.196 13.7 13.7 0 0 1 5.39 3.025 1.14 1.14 0 0 0 1.614-.083 1.143 1.143 0 0 0-.082-1.614c-1.845-1.663-3.96-2.849-6.285-3.524M13.098 13.2a1.14 1.14 0 0 0-1.414-.78 16 16 0 0 0-6.298 3.516 1.144 1.144 0 0 0 1.53 1.7 13.7 13.7 0 0 1 5.4-3.021c.607-.175.957-.808.782-1.414ZM20.57 19.189a1.143 1.143 0 0 0-1.139 1.982c.5.288.907.575 1.246.877a1.144 1.144 0 0 0 1.523-1.705 9.6 9.6 0 0 0-1.63-1.154M11.433 19.18a9.6 9.6 0 0 0-1.639 1.156 1.142 1.142 0 1 0 1.522 1.705c.34-.302.75-.59 1.252-.877a1.143 1.143 0 1 0-1.135-1.984ZM16 21.869c.63 0 1.143-.512 1.143-1.143V5.746a1.143 1.143 0 0 0-2.286 0v14.98c0 .631.512 1.143 1.143 1.143"
    })]
  }));
};
SignalPoorIcon.displayName = 'SignalPoorIcon';